import { dataImport } from 'dls-icons-data'
import { createIcon } from '../common'

const IconImport = /*#__PURE__*/createIcon(dataImport)
export default IconImport
